var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"appTitle"},[_c('b-jumbotron',{attrs:{"header":_vm.appName,"lead":"Genomic data for a wide range of species to study the evolution of symbiosis"}},[_c('b-btn',{attrs:{"variant":"primary"}},[_c('router-link',{attrs:{"tag":"div","to":"/about"}},[_vm._v("More info")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }